<!-- header start -->
<header class="sticky fixed" [ngClass]="class" [class.fixed]="stick && sticky">
  
  
  
    <div class="row w-100">
     
       
          <div class="d-flex flex-row justify-content-between w-100">
                          
          
           
            <div class="align-items-center ml-2">
              <a (click)="OnIconClick()" >
                <img [src]="themeLogo" class="img-fluid logo-img web-view mobileView" style="width: auto; height: 50px; padding-left: 10px;"alt="logo" />
                <img [src]="themeLogo" class="img-fluid logo-img  mobi-view" style="width: 90px; height: 30px; padding-left: 10px;"alt="logo" />
              </a>
            </div>
            <div class="align-items-center ml-2">
              <app-location></app-location>
            </div>
            <!-- <a [routerLink]="['/']">
              <img [src]="themeIcon" class= "mobi-view"/>
            </a> -->
            

            
        
          <div class="genie-headinggg ml-2 align-self-center font-weight-bold" *ngIf="genieName">
           <h4>{{genieName  || 'Store'}}</h4> 
          </div>
          <!-- <div style="padding-left: 10px !important; margin-top: 1.25rem;">
           <a class="cursor-pointer">{{genieName}}</a>
          </div> -->
          <div class="profile d-flex align-items-center" >
            <div class="button-container"  >
              <div class="d-flex" style="gap: 0.5rem;">
                <i class="fa fa-user fa-1x cursor-pointer  align-self-center" *ngIf="loggeedUser$ | async as loggedUser" (mouseover)="toggleCard()" (mouseleave)="hideCard()"  (click)="toggleCard()"></i>
                <span class="hover-button cursor-pointer" *ngIf="loggeedUser$ | async as loggedUser" (mouseover)="showCard()" (mouseleave)="hideCard()" (click)="toggleCard()">{{(loggedUser?.name.length>20) 
                  ?(loggedUser?.name | slice:0:20)+ '...'
                   :(loggedUser?.name)}}</span>

                   <div #elseBlock *ngIf="!isAuthUser" class="d-flex" style="gap: 0.5rem;">
                    <i class="fa fa-user fa-1x cursor-pointer  align-self-center" *ngIf="user" (mouseover)="toggleCard()" (mouseleave)="hideCard()"  (click)="toggleCard()"></i>
                    <span class="hover-button cursor-pointer" *ngIf="user" (mouseover)="showCard()" (mouseleave)="hideCard()" (click)="toggleCard()">{{(user?.userName.length>20) 
                      ?(user?.userName | slice:0:20)+ '...'
                       :(user?.userName)}}</span>
                   </div>
                   
              </div>
             
              <div class="card-container" [ngClass]="{ 'show-card': isCardVisible }">
                <div class="card p-2" style="width: max-content;" (mouseover)="showCard()" (mouseleave)="hideCard()">
                  <a class="cursor-pointer text-dark"  data-lng="en" (click)="navigate('myorders')"> My Orders </a>
                  <a class="cursor-pointer text-dark" (click)="navigate('myaddress')"  data-lng="en"> My Address </a>
                  <a class="cursor-pointer text-dark" (click)="navigate('myprofile')"    data-lng="en"> My Profile </a>
                  <a class="cursor-pointer text-dark" (click)="logout()" data-lng="en"> Logout </a>
                </div>
              </div>
            </div>
            
            <!-- <app-settings
              *ngIf="loadingAction"
              [isLogin]="isLogin"
              [isCart]="isCart"
            ></app-settings> -->
          
          </div>
          </div>
          <form class="form_search" role="form" *ngIf="isHomePage">
            <input
              id="query search-autocomplete"
              type="search"
              placeholder="Find the best for your..."
              class="nav-search nav-search-field"
              aria-expanded="true"
            />
            <button type="button" name="nav-submit-button" class="btn-search">
              <i class="ti-search"></i>
            </button>
          </form>
          <!-- <a [routerLink]="['/pages/useraccount']" *ngIf="isLogin"
              >User</a
            > -->

       
       
     
    </div>
  
  <!-- <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="main-nav-center">
            <app-menu></app-menu>
          </div>
        </div>
      </div>
    </div> -->
</header>
<!-- header end -->
